<template>
    <div class="DataRoluser">
        <template v-for="itemRolList of this.listRol">
            <div
                class="status text-left"
                :key="itemRolList.idRole"
            >
                    <div class="custom-control custom-checkbox mr-sm-2">
                        <input
                        type="checkbox"
                        v-model="modelRol[itemRolList.idRole]"
                        :id="itemRolList.idRole"
                        class="custom-control-input"
                        />
                        <label class="custom-control-label" :for="itemRolList.idRole">{{itemRolList.namRole}}</label>
                    </div>
            </div>
        </template>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'DataRoluser',
  data () {
    return {
      listRol: [],
      modelRol: {},
    }
  },
  props: {
    method: Function,
    InfoView: Object,
  },
  methods: {
    loadModel (idRole, filterlist) {
      var itemList = filterlist.filter(item => {
        if (item.idRole === idRole) {
          return item
        }
      })
      if (itemList.length === 1) {
        return true
      } else {
        return false
      }
    },
    loadRoles () {
      let loader = this.$loading.show()
      var RolData = IberoHelpers.getRolData(this.$store)
      RolData.then(Response => {
        if (Response.data) {
          this.listRol = Response.data
          for (var i = 0; i < Response.data.length; i++) {
            this.modelRol[Response.data[i].idRole] = this.loadModel(Response.data[i].idRole, this.InfoView.CodRoles)
          }
        } else {
          this.refNoRol = true
        }
        loader.hide()
      })
    },
  },
  created () {
    this.loadRoles()
  },
}
</script>

<style scope>
.DataRoluser {
  padding: 30px !important;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before{
  background-color:#F65A6F;
}

.custom-control-label{
    cursor: pointer;
}
</style>
